import React, { Component } from "react";

import Timeline from "./components/timeline/Timeline.js";
import CurveEdit from "./components/canvas/CurveEdit.js";
import Window from "./components/windows/Window.js";
import CurveEditWindow from "./components/windows/CurveEditWindow.js";
import Container from "./components/windows/Container.js";
import Canvas from "./components/canvas/Canvas.js";
import TestCanvas from "./components/canvas/TestCanvas.js";
import Colors from "./utils/Colors.js";

import TOwOject from "./components/canvas/TOwObject.js";

import { observable } from "mobx";
import { observer } from "mobx-react";

import "./Animations.css";

/*
<Container className="Container" width={window.innerWidth - 275} height={window.innerHeight - 200}>
  <CurveEditWindow className="curveEditWindow" startPosition='topLeft' />
</Container>

*/

@observer
class App extends Component {
    prevBoxStyle = null;
    keyframesObj = [
        {
            property: "top",
            keyframes: [
                {
                    time: 0,
                    value: 20
                },
                {
                    time: 200,
                    value: 100,
                    easing: "easeInOut"
                },
                {
                    time: 400,
                    value: 50,
                    easing: "ease"
                },
                {
                    time: 600,
                    value: 300,
                    easing: "easeInOut"
                },
                {
                    time: 800,
                    value: 100,
                    easing: "easeInOut"
                },
                {
                    time: 1000,
                    value: 50,
                    easing: "ease"
                },
                {
                    time: 1500,
                    value: 300,
                    easing: "easeInOut"
                }
            ],
            color: Colors.rgb(0, 150, 255)
        },
        {
            property: "opacity",
            color: Colors.rgb(255, 50, 200),
            keyframes: [
                {
                    time: 0,
                    value: 1
                },
                {
                    time: 600,
                    value: 0,
                    easing: "easeInOut"
                }
            ]
        }
    ];

    constructor(props) {
        super(props);
        this.box = React.createRef();
        this.test = React.createRef();
    }

    testlol(prop, amount) {
        console.log(this.refs);
        const curveEdit = this.refs.abcd;
        if (curveEdit) {
            curveEdit.setProperty(prop);
            const keyframes = Object.assign(
                this.keyframesObj.find(kfo => kfo.property === prop)
            );
            keyframes.keyframes = keyframes.keyframes.slice(
                0,
                amount ? amount : keyframes.keyframes.length
            );
            curveEdit.updateKeyframes(keyframes);
            curveEdit.loadKeyframes(false);
        }
    }

    onCurveUpdate(e) {
        const prop = e.property;
        const kfobj = this.keyframesObj.find(kf => kf.property === prop);

        const keyframes = e.keyframes;
        kfobj.keyframes = keyframes || kfobj.keyframes;

        const testCanvas = this.refs.testCanvas;
        if (testCanvas) {
            testCanvas.notify(prop, kfobj.keyframes);
        }

        if (!this.box.current) return;
        const box = this.box.current;
        const animationData = e.data;

        switch (e.name) {
            case "preview":
                box.style[prop] = animationData.value + this.getUnit(prop);
                break;

            default:
                break;
        }
    }

    getUnit(prop) {
        switch (prop) {
            case "top":
            case "left":
            case "right":
            case "bottom":
                return "px";

            case "opacity":
                return "";

            default:
                return "";
        }
    }

    // render() {
    //     return (
    //         <div className="App">
    //             <Timeline ref="test" width={500} height={500} />
    //         </div>
    //     );
    // }

    // render() {
    //   return (
    //     <div className="App">
    //       <Container className="Container" width={window.innerWidth - 275} height={window.innerHeight - 200}>
    //         <CurveEditWindow ref='curveEditWindow' className="curveEditWindow" startPosition='topLeft' keyframes={this.keyframesObj[0]} onCurveUpdate={this.onCurveUpdate.bind(this)} />
    //         <Window startPosition={'bottomLeft'} title={'TEST'} draggable width={750} height={200}>
    //           <TestCanvas keyframes={this.keyframesObj} ref='testCanvas' width={700} height={100} className="testKF" test={this.testlol.bind(this)} />
    //         </Window>
    //       </Container>
    //       <div className="box1" ref={this.box}></div>
    //     </div>
    //   );
    // }

    // componentDidUpdate() {
    //   console.log('noice');
    // }

    render() {
        return (
            <div className="App">
                <CurveEdit
                    ref="curveEdit"
                    property={"top"}
                    width={500}
                    height={350}
                    keyframes={this.keyframesObj[0]}
                    onCurveUpdate={this.onCurveUpdate.bind(this)}
                />
                <div className="box1" ref={this.box} />

                {/* <TOwOject ref='tobj' className="testKF" width={300}
          height={31} keyframes={this.keyframes} /> */}

                <TestCanvas
                    keyframes={this.keyframesObj}
                    ref="testCanvas"
                    width={1000}
                    height={300}
                    className="testKF"
                    test={this.testlol.bind(this)}
                />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js